import { getCurrentLocale } from '../helper'

// Returns '' for null/undefined amounts (e.g. a price that isn't set yet).
export function formatCurrency(amount, currency = 'SEK') {
  if (amount === null || amount === undefined) {
    return ''
  }

  const locale = getCurrentLocale()

  return new Intl.NumberFormat(locale.code, {
    currency,
    style: 'currency',
    minimumFractionDigits: 0,
  }).format(amount)
}
